/* DACOBI engraving reconciler, sitewide (owner 10-14 bug: an engraved knife removed from the cart on a lander left its
 * hidden engraving fee in the cart, charged at checkout). Same logic as the reconciler inside blocks/dacobi-engraving.liquid,
 * which only loads on product pages. One instance per page: whichever installs first owns window.__dacobiEngraving.
 * Config from layout/theme.liquid: window.__dacobiEngravingCfg = { fee, prop, forLabel }.
 * Rules: a fee without its knife (by _pair token or legacy _for_key) is removed; a fee follows its knife's quantity;
 * an engraved knife without a fee gets one (its own add request). Runs on load and after every cart:update. */
(function () {
  var cfg = window.__dacobiEngravingCfg;
  if (!cfg || !cfg.fee || window.__dacobiEngraving) return;
  var state = window.__dacobiEngraving = { busy: false };
  var routes = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var feeId = parseInt(cfg.fee, 10);

  function cartFetch(path, body) {
    var opts = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }
      : { headers: { 'Accept': 'application/json' } };
    return fetch(routes + path, opts).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function sectionIds() {
    return Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (c) { return c.dataset.sectionId; }).filter(Boolean).join(',');
  }
  function itemCountFrom(sectionsObj) {
    try {
      for (var key in sectionsObj) {
        if (!sectionsObj[key]) continue;
        var el = new DOMParser().parseFromString(sectionsObj[key], 'text/html').querySelector('[ref="cartItemCount"]');
        if (el && el.textContent.trim() !== '') return parseInt(el.textContent, 10);
      }
    } catch (e) {}
    return null;
  }
  function notify(last) {
    var dispatch = function (count, sections, resource) {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: resource || {}, sourceId: 'dacobi-engraving', data: { source: 'dacobi-engraving', itemCount: count, sections: sections } };
      document.dispatchEvent(ev);
    };
    var sections = last && last.sections;
    if (sections) { var n = itemCountFrom(sections); if (n != null) return dispatch(n, sections, last); }
    cartFetch('cart.js').then(function (r) {
      var count = r.j.item_count;
      (r.j.items || []).forEach(function (i) { if (i.variant_id === feeId) count -= i.quantity; });
      dispatch(count, sections, r.j);
    }).catch(function () {});
  }
  function reconcile() {
    if (state.busy) return;
    state.busy = true; state.busyAt = Date.now();
    cartFetch('cart.js').then(function (res) {
      if (!res.ok) throw new Error('cart fetch failed');
      var items = res.j.items || [];
      var fees = items.filter(function (i) { return i.variant_id === feeId; });
      var knives = items.filter(function (i) { return i.variant_id !== feeId && i.properties && i.properties._engraving_text; });
      var ops = [], paired = {};
      fees.forEach(function (f) {
        var fp = f.properties || {}, group;
        if (fp._pair && !fp._for_key) group = knives.filter(function (k) { return k.properties._pair === fp._pair; });
        else { var one = fp._for_key ? knives.find(function (k) { return k.key === fp._for_key; }) : null; group = one ? [one] : []; }
        var taken = group.some(function (k) { return paired[k.key]; });
        if (!group.length || taken) { ops.push({ type: 'change', key: f.key, qty: 0 }); return; }
        var want = 0;
        group.forEach(function (k) { paired[k.key] = f; want += k.quantity; });
        if (f.quantity !== want) ops.push({ type: 'change', key: f.key, qty: want });
      });
      knives.forEach(function (k) { if (!paired[k.key]) ops.push({ type: 'add', knife: k }); });
      if (!ops.length) return null;
      var adds = [], updates = {};
      ops.forEach(function (op) {
        if (op.type === 'add') {
          var props = {};
          if (op.knife.properties._pair) props._pair = op.knife.properties._pair; else props._for_key = op.knife.key;
          props[cfg.forLabel || 'For'] = op.knife.product_title;
          props[cfg.prop] = op.knife.properties._engraving_text;
          adds.push({ id: feeId, quantity: op.knife.quantity, properties: props });
        } else updates[op.key] = op.qty;
      });
      var secs = sectionIds(), hasUpdates = Object.keys(updates).length > 0, last = null;
      var withSections = function (b, isLast) { if (isLast && secs) { b.sections = secs; b.sections_url = location.pathname; } return b; };
      var chain = Promise.resolve();
      // A missing fee is added one per request (each its own add-to-cart event, never batched with anything).
      adds.forEach(function (a, i) {
        chain = chain.then(function () {
          return cartFetch('cart/add.js', withSections({ items: [a] }, !hasUpdates && i === adds.length - 1)).then(function (r) { if (r.ok) last = r.j; });
        });
      });
      if (hasUpdates) chain = chain.then(function () {
        return cartFetch('cart/update.js', withSections({ updates: updates }, true)).then(function (r) { if (r.ok) last = r.j; });
      });
      return chain.then(function () { return { json: last }; });
    }).then(function (result) {
      state.busy = false;
      if (result) notify(result.json);
    }).catch(function (err) { state.busy = false; console.warn('[dacobi-engraving] reconcile error', err); });
  }
  function schedule(e) {
    if (e && e.detail && e.detail.sourceId === 'dacobi-engraving') return;
    if (state.busy && Date.now() - (state.busyAt || 0) > 15000) state.busy = false;
    if (state.busy) return;
    setTimeout(reconcile, 50);
  }
  document.addEventListener('cart:update', schedule);
  if (document.readyState === 'complete') schedule(); else window.addEventListener('load', function () { schedule(); });
})();
